import { ProductNavigation } from "../../../../components/ui/ProductNavigation";
import { ModuleSidebar } from '../../../../components/ui/ModuleSidebar';
import { findProductModule } from '../../../../components/ui/ProductNavigation/navigation-data';
import { ClassroomSchedulePage } from "./app/ClassroomSchedulePage";
import styles from './Page.module.css';

const educationModule = findProductModule('education');

export function ClassroomScheduleV2Page() {
  return (
    <main className={styles.page}>
      <ProductNavigation defaultActive="教务管理" />
      <div className={styles.workspace}>
        <ModuleSidebar
          activeItem="课表和点名"
          ariaLabel="教务管理导航"
          groups={educationModule?.groups ?? []}
        />
        <section aria-label="教室课表页面">
          <h1 className={styles.visuallyHidden}>教室课表</h1>
          <ClassroomSchedulePage />
        </section>
      </div>
    </main>
  );
}
